var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_warning__medium",
    "data-name": "icon_warning_ medium",
    transform: "translate(-0.222 -0.222)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 22,
    height: 22,
    transform: "translate(0.222 0.222)",
    fill: "#6639B7",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_warning__medium-2",
    "data-name": "icon_warning_ medium",
    transform: "translate(1.403 1.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3166",
    "data-name": "Groupe 3166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_214",
    "data-name": "Trac\\xE9 214",
    d: "M9.819,0a9.819,9.819,0,1,0,9.819,9.819A9.819,9.819,0,0,0,9.819,0m1.653,15.069a1.653,1.653,0,0,1-3.307,0v-.04a1.653,1.653,0,1,1,3.307,0Zm.039-11.025L10.695,11.2a.878.878,0,0,1-1.755,0L8.129,4.038a.777.777,0,0,1,.56-.945.765.765,0,0,1,.195-.024h1.857a.8.8,0,0,1,.79.813.774.774,0,0,1-.019.161Z",
    fill: "#6639B7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.a7b6dae968457b4add47db3c195bf313.svg";
export { ForwardRef as ReactComponent };